import axios from "axios";
import { baseURL } from "../Constants";
import { RosterTransfer, TransferFilters, TransfersResponse, TransferStats } from "../models/RosterTransfer";

const url = `${baseURL}/transfer`;

export const fetchTransfers = async (filters: TransferFilters = {}): Promise<TransfersResponse> => {
    try {
        const params = new URLSearchParams();

        if (filters.season !== undefined) params.append('season', filters.season.toString());
        if (filters.division) params.append('division', filters.division);
        if (filters.teamId) params.append('teamId', filters.teamId);
        if (filters.playerSteamId) params.append('playerSteamId', filters.playerSteamId);
        if (filters.playerName) params.append('playerName', filters.playerName);
        if (filters.teamName) params.append('teamName', filters.teamName);
        if (filters.limit !== undefined) params.append('limit', filters.limit.toString());
        if (filters.offset !== undefined) params.append('offset', filters.offset.toString());

        const response = await axios.get(`${url}?${params.toString()}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching transfers:', error);
        throw error;
    }
};

export const fetchRecentTransfers = async (count: number = 20): Promise<RosterTransfer[]> => {
    try {
        const response = await axios.get(`${url}/recent?count=${count}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching recent transfers:', error);
        throw error;
    }
};

export const fetchPlayerTransfers = async (steamId: string): Promise<RosterTransfer[]> => {
    try {
        const response = await axios.get(`${url}/player/${steamId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching player transfers:', error);
        throw error;
    }
};

export const fetchTeamTransfers = async (teamId: string, season?: number): Promise<RosterTransfer[]> => {
    try {
        const params = season !== undefined ? `?season=${season}` : '';
        const response = await axios.get(`${url}/team/${teamId}${params}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching team transfers:', error);
        throw error;
    }
};

export const fetchDivisions = async (): Promise<string[]> => {
    try {
        const response = await axios.get(`${url}/divisions`);
        return response.data;
    } catch (error) {
        console.error('Error fetching divisions:', error);
        throw error;
    }
};

export const fetchTransferStats = async (season?: number): Promise<TransferStats> => {
    try {
        const params = season !== undefined ? `?season=${season}` : '';
        const response = await axios.get(`${url}/stats${params}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching transfer stats:', error);
        throw error;
    }
};
